import {observer} from "mobx-react-lite";
import * as React from "react";
import {IocData} from "../../models/ioc";
import {Table} from "react-bootstrap";
import DateRow from "../DateRow";
import TargetRow from "../TargetRow";

const IocDataTable = observer(function IocDataTable(props: { data: IocData[] }) {
    if (!props.data.length) {
        return <div>No data</div>
    }

    return <Table striped>
        <thead>
        <tr>
            <th>IOC</th>
            <th>First Identified</th>
            <th>Last Time Present</th>
            <th>Present in Targets</th>
        </tr>
        </thead>
        <tbody>
        {props.data.map((v, i) => <tr key={i}>
            <td>{v.record}</td>
            <td><DateRow timestamp={v.first_identified}/></td>
            <td>
                {v.last_used === v.blocker.last_update ? 'Now' : <DateRow timestamp={v.last_used}/>}
            </td>
            <td>
                <TargetRow target={v.blocker} />
            </td>
        </tr>)}
        </tbody>
    </Table>
})

export default IocDataTable